import {
  faBinoculars,
  faCalendarAlt,
  faEnvelope,
  faNoteSticky,
  faPhone,
} from '@fortawesome/pro-regular-svg-icons';

export const activityTypes = {
  call: {
    icon: faPhone,
    key: 'call',
    label: 'Call',
    phrase: 'logged a call',
  },

  message: {
    icon: faEnvelope,
    key: 'message',
    label: 'Email',
    phrase: 'logged an email',
  },

  meeting: {
    icon: faCalendarAlt,
    key: 'meeting',
    label: 'Meeting',
    phrase: 'logged a meeting',
  },

  showing: {
    icon: faBinoculars,
    key: 'showing',
    label: 'Tour',
    phrase: 'logged a tour',
  },

  note: {
    icon: faNoteSticky,
    key: 'note',
    label: 'Note',
    phrase: 'logged a note',
  },
};
